import checkFF from '@webapp-next/lib/feature-flag';

export function checkEndEmploymentFF(): boolean {
  return checkFF('payx-262-enable-employment-end-date-and-reason');
}

export function checkEmploymentCollapseFF(): boolean {
  return checkFF('pre-6114-employment-collapse');
}

export function checkShiftHandlingChooserFF(): boolean {
  return checkFF('payx-2419-shift-handling-chooser');
}

export function checkJobTitlesFF(): boolean {
  return checkFF('chip-1232-job-title');
}

export function checkJobTitlesFlatfileTemplateFF(): boolean {
  return checkFF('chip-1232-job-title-flatfile-template');
}

/**
 * The job title Flatfile import rides both flags: the M1 flag still governs
 * whether job titles exist for the tenant at all, and the template flag
 * governs the import surface on top of it.
 */
export function checkJobTitlesFlatfileImportFF(): boolean {
  return checkJobTitlesFF() && checkJobTitlesFlatfileTemplateFF();
}

export function checkSingleProfileEmployeeFetchFF(): boolean {
  return checkFF('chip-2599-profile-single-employee-fetch');
}

export function checkSuperviseEmployeeWithoutAgreementsFF(): boolean {
  return checkFF('chip-2687-supervise-employee-without-agreements');
}

const COLLAPSE_AGREEMENT_THRESHOLD = 1000;

export function isAboveCollapseThreshold(agreementCount: number): boolean {
  return agreementCount > COLLAPSE_AGREEMENT_THRESHOLD;
}
